import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-shuttle',
  templateUrl: './shuttle.component.html',
  styleUrls: ['./shuttle.component.scss']
})
export class ShuttleComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() items: any[];//all the availabe items that can be selected
  @Input() selectedItems: any[];//pre selected items if exists, otherwise send any empty array so you can know the final output of the user selection
  @Input() label: string;
  @Input() dataLabel?: string;//label for the data itself inside items/selectedItems, can be null if it's a simple type object
  @Input() secondaryDataLabel?: string;//secondary label for the data itself inside items/selectedItems, can be null if it's a simple type object
  @Input() compareBy?: string;//object comparison
  @Input() activeFieldName?: string;//if this field-name is sent, the inactive items are dimmed

  @Output() onSelect?: EventEmitter<any> = new EventEmitter();
  @Output() onRemove?: EventEmitter<any> = new EventEmitter();
  @Output() onSelectAll?: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveAll?: EventEmitter<any> = new EventEmitter();

  allItems: any[];//a copy of items array to work on inside the component, for manipulation purposes
  selectedItemsSearch: string;
  allItemsSearch: string;

  constructor() {
    super();
    this.items = [];
    this.allItems = [];
    this.selectedItems = [];
    this.label = "";
  }

  ngOnInit(): void {
    this.prepareData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["items"] && changes["items"].currentValue) {
      this.allItems = changes["items"].currentValue.slice();//copy
    }
    this.prepareData();
  }

  prepareData(): void {
    this.selectedItemsSearch = null;//reset
    this.allItemsSearch = null;//reset
    if (this.allItems && this.allItems.length > 0) {
      for (let i = 0; i < this.allItems.length; i++) {
        let item = this.allItems[i];
        item["show"] = true;
        this.setItemLabel(item);
      }
    }

    if (this.selectedItems && this.selectedItems.length > 0) {
      for (let i = 0; i < this.selectedItems.length; i++) {
        let item = this.selectedItems[i];
        item["show"] = true;
        this.setItemLabel(item);
        this.allItems = this.allItems.filter(e => !this.isEqual(e, item));
      }
    }
  }

  setItemLabel(item: any) {
    let label = "";
    if (!this.util.isStringEmpty(this.dataLabel)) {
      label = this.util.getDeepValue(item, this.dataLabel);
    }
    if (!label && !this.util.isStringEmpty(this.secondaryDataLabel)) {
      label = this.util.getDeepValue(item, this.secondaryDataLabel);
    }
    item["shuttleLabel"] = label;
    return item;
  }

  selectItem(item: any): void {
    item.show = true;//reset
    let existedItem = this.selectedItems.find(e => this.isEqual(e, item));
    if (!existedItem) {
      this.selectedItems.push(item);
      this.allItems = this.allItems.filter(e => !this.isEqual(e, item));
      this.onSelect.emit(item);
    }
  }

  removeItem(index: number, item: any): void {
    this.selectedItems.splice(index, 1);
    this.allItems.push(item);
    item.show = true;//reset
    this.onRemove.emit(item);
  }

  selectAll(): void {
    let itemsToAdd = [];
    OUTER: for (let item of this.allItems) {
      for (let selectedItem of this.selectedItems) {
        if (this.isEqual(selectedItem, item)) {
          continue OUTER;
        }
      }
      itemsToAdd.push(item);
    }

    for (let item of itemsToAdd) {
      item.show = true;//reset
      this.selectedItems.push(item);//keep reference
    }

    this.allItems = [];
    this.selectedItemsSearch = null;//reset
    this.allItemsSearch = null;//reset

    this.onSelectAll.emit(itemsToAdd);
  }

  removeAll(): void {
    let itemsToRemove = this.selectedItems.slice();//copy
    this.selectedItems.splice(0, this.selectedItems.length);//empty array without losing reference
    this.allItems = this.items.slice();//copy
    for (let item of this.allItems) {
      item.show = true;//reset
    }
    this.selectedItemsSearch = null;//reset
    this.allItemsSearch = null;//reset

    this.onRemoveAll.emit(itemsToRemove);
  }

  isEqual(item1: any, item2: any): boolean {
    if (!item1 || !item2) {
      return false;
    }
    return this.compareBy ? item1[this.compareBy] === item2[this.compareBy] : item1 === item2;
  }

  onSearch(allItems: boolean): void {
    let items = allItems ? this.allItems : this.selectedItems;
    let searchTxt = allItems ? this.allItemsSearch : this.selectedItemsSearch;
    searchTxt = this.util.isStringEmpty(searchTxt) ? "" : searchTxt.toLowerCase();//empty string so includes returns true
    for (let item of items) {
      item.show = item.shuttleLabel.toLowerCase().includes(searchTxt);
    }
  }

}
